<script lang="ts">
import { defineComponent } from 'vue'

import Alert from '@mobile/components/Alert/Alert.vue'
import Button from '@mobile/components/Button/Button.vue'

export default defineComponent({
  components: {
    Alert,
    Button,
  },
  emits: ['confirm', 'close'],
})
</script>

<template>
  <Alert>
    <strong>
      Are you sure you want to save lineups? Number of players in first lineup
      is invalid.
    </strong>
    <template #controls>
      <Button
        class="mx-2"
        color="blue"
        :invertedColor="true"
        size="sm"
        @click="$emit('close')"
      >
        Cancel
      </Button>
      <Button
        class="mx-2"
        color="blue"
        size="sm"
        @click="$emit('confirm')"
      >
        Save lineups
      </Button>
    </template>
  </Alert>
</template>
